import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuInput, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  metaData = [],
  satusData = [],
  id,
  getCompletion = () => {},
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    training_program: "",
    function_responsibility: "",
    frequency: "",
    participants: "",
    mandatory: "",
    detail_plan: "",
    planned_date: "",
    artifact: "",
    status: "",
  });
  useEffect(() => {
    setCreateNew({
      training_program: data?.training_program,
      function_responsibility: data?.function_responsibility,
      frequency: data?.frequency,
      participants: data?.participants,
      mandatory: data?.mandatory,
      detail_plan: data?.detail_plan,
      planned_date: data?.planned_date,
      artifact: data?.artifact,
      status: data?.status,
    });
    setFilePathList(data?.artifact)
    setRemoveFilePathList(data?.artifact)
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit:  async (value, { resetForm }) => {
      if (data?.id) {
        if(!value.planned_date){
            value.planned_date = "None"
          }
  
  
          let finalArr = removefilePathList.filter(items=>  !filePathList.includes(items) )
          value.files_to_remove = finalArr.map(item=>item.replace(window.WEB_APP_API_URL, "localhost"));
          let formdata = new FormData();
          if(selectedFile !== null){
            selectedFile.forEach((file) => {
              formdata.append("attachment_artifact", file);
            });
          } else{
            formdata.append("attachment_artifact",[]);
          } 
          value.status = value.status.toLowerCase();
          formdata.append("training_data", JSON.stringify(value));
        await ScreenClose({ link: "Training-Calender", id: data.id });
        await editData({
          url: `/Training-Calender/${data.id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      } else {
        value.standard_id = Number(id);
        let formdata = new FormData();
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        }
        formdata.append("training_data", JSON.stringify(value));
        addData({
          url: `/Training-Calender/standard/${id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          otherFunction: getCompletion,
        });
      }
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    if(data){
      ScreenClose({ link: "Training-Calender", id: data.id });
    }
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <NuInput
                formik={formik}
                name="training_program"
                label="Training Program"
                width="w-1/2"
                placeholder="Training Program"
              />
              <NuInput
                formik={formik}
                name="function_responsibility"
                label="Function Responsibility"
                width="w-1/2"
                placeholder="Function Responsibility"
              />
              <FormikSelectTwo
                formik={formik}
                name="frequency"
                label="Frequency"
                width="w-1/2"
                placeholder="Select Frequency"
                Options={metaData}
                zindex={12}
              />
              <NuInput
                formik={formik}
                name="participants"
                label="Participants"
                width="w-1/2"
                placeholder="Participants"
              />
              <NuInput
                formik={formik}
                name="mandatory"
                label="Mandatory for the organization"
                width="w-1/2"
                placeholder="Mandatory for the organization"
              />
              <NuInput
                formik={formik}
                name="detail_plan"
                label="Detail Plan"
                width="w-1/2"
                placeholder="Detail Plan"
              />
              <NuDate
                name="planned_date"
                label="Planned Date"
                width="w-1/2"
                formik={formik}
                min={data ? "" : NuDateFormat({
                  value: Date.now(),
                  format: "yyyy-MM-DD",
                })}
              />
              <FormikSelectTwo
                formik={formik}
                name="status"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={satusData}
                zindex={12}
              />
              <NuUpload
                label="Incident Report / ATR Report"
                width="w-1/2"
                onChange={handleImageChange}
                multiple={true}
              />
              <div className=" w-full flex flex-wrap ">
                {data?.artifact &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay
                            data={i}
                            view={true}
                            height={"45px"}
                            width={"45px"}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
